module.exports = __webpack_public_path__ + "img/farm.ace7a411.svg";